import { Prices as PricesComponent } from '../components';

const Prices = () => {
   return <PricesComponent />;
};

export default Prices;
